import SerialNumberMaskedInput from './SerialNumberMaskedInput';

export default SerialNumberMaskedInput;
